import React from 'react';
import NavDropdown from "./NavDropdown";
import NavDropdownItem from './NavDropdownItem';
import NavItem from './NavItem';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';

function NavbarNav(props) {

    let user = new SessionManager().readCookie('user', false);
    let nav_paths = props.nav;
    const workflow_steps = ["KickOffScheduled", "OrderProcessed", "ProductShipped", "ScheduledInstaller"];
    if (user && user.site_selected && workflow_steps.indexOf(user.site_selected.site_state) !== -1)
        nav_paths = nav_paths.filter(n => n.id === '01');

    return (
        nav_paths.map((navRec, i) => (
            <ul key={i} className={navRec.className}>
                {
                    navRec.nav.map((item) => (
                        (!item.permission || CommonUtils.hasPermission(item.permission)) && (
                            (item.path || (!item.nav || item.nav.length === 0)) ?
                                <NavItem auth={navRec.auth} key={item.id} nav_id={item.id} {...item} /> :
                                (
                                    <NavDropdown key={item.id} name={item.name} {...item} >
                                        {
                                            item.nav.map((menuItem) => (
                                                (!menuItem.permission || CommonUtils.hasPermission(menuItem.permission)) && (
                                                    <NavDropdownItem auth={navRec.auth} key={menuItem.id} id={menuItem.ref_id} {...menuItem} />
                                                )
                                            ))
                                        }
                                    </NavDropdown>
                                )
                        ))
                    )
                }
            </ul>))
    );
}

export default NavbarNav;